/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Phone_MinInputs */

const vi_validation_phone_min = /** @type {(inputs: Validation_Phone_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số điện thoại tối thiểu 8 ký tự`)
};

/**

* @param {Validation_Phone_MinInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_phone_min = /** @type {((inputs?: Validation_Phone_MinInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Phone_MinInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_phone_min(inputs)
});